import { render, staticRenderFns } from "./DuolifangzhuanItem.vue?vue&type=template&id=f3da32f8&"
import script from "./DuolifangzhuanItem.vue?vue&type=script&lang=js&"
export * from "./DuolifangzhuanItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports